/**
 * Client outline search: dump the tree, then keep matches and their ancestors. Generic over the row
 * type so the board's own row shape survives the filter — the grid compares what it gets back.
 */
import { OutlineRow } from './outline.authoring.model';

export function filterOutlineSearchRows<TRow extends Pick<OutlineRow, '_id' | 'parentId' | 'name' | 'description' | 'hasChildren'>>(rows: readonly TRow[], search: string): TRow[] {

  const query = search.trim().toLowerCase();
  if (!query) return [...rows];
  const byId = new Map(rows.map(row => [row._id, row]));
  const keep = new Set<string>();
  for (const row of rows) {
    if (!`${row.name ?? ''} ${row.description ?? ''}`.toLowerCase().includes(query)) continue;
    let current: TRow | undefined = row;
    while (current && !keep.has(current._id)) {
      keep.add(current._id);
      current = current.parentId ? byId.get(current.parentId) : undefined;
    }
  }
  return rows
    .filter(row => keep.has(row._id))
    .map(row => ({ ...row, hasChildren: rows.some(child => child.parentId === row._id && keep.has(child._id)) }));
}
